"use client";

import { c as _c } from "react/compiler-runtime";
import { IconShoppingCart } from "@tabler/icons-react";
export function EmptyCart() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-1 flex-col items-center justify-center gap-4 text-muted-foreground"><IconShoppingCart className="size-16" data-testid="empty-cart-icon" /><p className="text-lg font-medium">Your cart is empty!</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}